import React from 'react';
import $ from 'jquery';

/* eslint no-underscore-dangle: ["error",
{ "allow": [
    "_config",
    "_render",
    "_destroy",
    "_container",
] }] */

const renderHandler = (component) => {
  const { reactContainer } = component._container.layoutManager; // Instance of GoldenLayoutComponent class
  if (reactContainer && reactContainer.componentRender) reactContainer.componentRender(component);
};

// ReactDOM.unmountComponentAtNode( this._container.getElement()[ 0 ] );
const destroyHandler = (component) => {
  component._container.off('open', component._render, component);
  component._container.off('destroy', component._destroy, component);
};

// the following method is absolute copy of the original, provided to prevent dependency on window.React
const getReactComponentHandler = (container, reactClass) => {
  // the following method is absolute copy of the original, provided to prevent dependency on window.React
  const defaultProps = {
    glEventHub: container.layoutManager.eventHub,
    glContainer: container,
  };
  const props = $.extend(defaultProps, container._config.props);
  return React.createElement(reactClass, props);
};

export default {
  renderHandler,
  destroyHandler,
  getReactComponentHandler,
};
